module.exports = __webpack_public_path__ + "img/nav-design-diamondearrings@2x.09cf037.webp";